/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTradeByIdOptions,
  GetTradeByIdStatus200,
  GetTradeByIdStatus400,
  GetTradeByIdStatus404,
  GetTradeByIdStatus500,
} from '../types/GetTradeById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTradeById } from '../clients/getTradeById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTradeByIdQueryKey = ({ path }: Omit<GetTradeByIdOptions, 'headers'>) =>
  [{ url: '/v1/trades/:trade_id', params: path }] as const

type GetTradeByIdQueryKey = ReturnType<typeof getTradeByIdQueryKey>

export function getTradeByIdQueryOptions(
  { path }: GetTradeByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTradeByIdQueryKey({ path })
  return queryOptions<
    GetTradeByIdStatus200,
    ResponseErrorConfig<GetTradeByIdStatus400 | GetTradeByIdStatus404 | GetTradeByIdStatus500>,
    GetTradeByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTradeById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get a trade by ID
 * {@link /v1/trades/:trade_id}
 */
export function useGetTradeById<
  TData = GetTradeByIdStatus200,
  TQueryData = GetTradeByIdStatus200,
  TQueryKey extends QueryKey = GetTradeByIdQueryKey,
>(
  { path }: { path: GetTradeByIdOptions['path'] | (() => GetTradeByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTradeByIdStatus200,
        ResponseErrorConfig<GetTradeByIdStatus400 | GetTradeByIdStatus404 | GetTradeByIdStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getTradeByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTradeByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetTradeByIdStatus400 | GetTradeByIdStatus404 | GetTradeByIdStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
